import React from "react";
import { Box, Container, Heading, Text, VStack, useColorModeValue, Button } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { TiltCard } from "../../common/TiltCard";
import { usePublicGlassSurface } from "../../common/publicVisual";

const SuccessStoriesIndex = () => {
  const muted = useColorModeValue("gray.600", "gray.400");
  const deep = useColorModeValue("gray.900", "white");
  const glass = usePublicGlassSurface();

  return (
    <Box as="main" bg="transparent" py={{ base: 10, md: 16 }} minH="70vh">
      <Container maxW="container.md" px={{ base: 4, md: 6 }}>
        <TiltCard tilt={7} borderRadius="2xl" borderWidth="1px" p={{ base: 6, md: 8 }} sx={{ transformStyle: "preserve-3d" }} {...glass}>
          <VStack spacing={5} align="stretch">
            <Heading as="h1" size="xl" color={deep}>
              Success stories
            </Heading>
            <Text color={muted} fontSize="md" lineHeight="tall">
              We&apos;re collecting publishable interviews with freelancers, flats, and small teams once they approve attribution.
              Want to nominate your workspace? Reach out—we love hearing how chores, splits, and boards sit together.
            </Text>
            <Button as={RouterLink} to="/contact-us" colorScheme="teal" variant="outline" alignSelf="flex-start">
              Share your story idea
            </Button>
            <Button as={RouterLink} to="/pricing" variant="ghost" alignSelf="flex-start" size="sm">
              See pricing →
            </Button>
          </VStack>
        </TiltCard>
      </Container>
    </Box>
  );
};

export default SuccessStoriesIndex;
